import { Component, HostListener, OnInit } from '@angular/core';
import { NavigationService } from 'src/app/core/services/navigation.service';

@Component({
  selector: 'app-error404',
  templateUrl: './error404.component.html',
  styleUrls: ['./error404.component.css'],
})
export class Error404Component implements OnInit {
  xs: boolean = false;
  sm: boolean = false;
  md: boolean = false;
  lg: boolean = false;
  xl: boolean = false;
  xxl: boolean = false;
  public innerWidth: any;

  constructor(private navigationService: NavigationService) {}

  /*Organizador modo desarrollo*/

  ngOnInit(): void {
    this.innerWidth = window.innerWidth;

    if (this.innerWidth < 576) this.xs = true;
    if (this.innerWidth >= 576) this.sm = true;
    if (this.innerWidth >= 768) this.md = true;
    if (this.innerWidth >= 992) this.lg = true;
    if (this.innerWidth >= 1200) this.xl = true;
    if (this.innerWidth >= 1400) this.xxl = true;
  }

  goHome(): void {
    this.navigationService.navigateToHome();
  }
}
